import Swiper, { Navigation, Pagination } from 'swiper'

Swiper.use([Navigation, Pagination])

$('.js-imageSlider').each((index, el) => {
  new Swiper($('.swiper-container', el)[0], {
    loop: true,
    spaceBetween: 0,
    navigation: {
      nextEl: $('.js-imageSliderNext', el)[0],
      prevEl: $('.js-imageSliderPrev', el)[0],
    },
    pagination: {
      el: $('.swiper-pagination', el)[0],
      type: 'bullets',
      clickable: true,
    },
  })
})
